import cn from 'classnames';
import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { useMedia } from '@/shared/hooks';
import { Icon } from '@/shared/ui';

import styles from './RecordingModalHeader.module.scss';

type Props = {
  title: ReactNode;
  className?: string;
  onCollapse: () => void;
};

// A recording modal's header: the title and, in place of the "×", an arrow
// that puts the modal away without ending what is in it.
export const RecordingModalHeader: FC<Props> = ({
  title,
  className,
  onCollapse,
}) => {
  const { isMobile } = useMedia();
  const { formatMessage } = useIntl();
  const collapseLabel = formatMessage({
    id: 'transcriptorRecording.collapse',
    defaultMessage: 'Collapse',
  });

  return (
    <div className={cn(styles.header, className)}>
      <h3 className={cn(styles.title, isMobile ? 'h2m' : 'h3')}>{title}</h3>
      <button
        type="button"
        className={styles.collapse}
        aria-label={collapseLabel}
        title={collapseLabel}
        data-component="recording-modal-collapse"
        onClick={onCollapse}
      >
        <Icon name="arrowDown" size={isMobile ? 32 : 40} />
      </button>
    </div>
  );
};
